"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_TITLE_MAX_LENGTH = void 0;
// (C) 2021 GoodData Corporation
exports.DASHBOARD_TITLE_MAX_LENGTH = 255;
//# sourceMappingURL=dashboard.js.map